import { render, staticRenderFns } from "./FakturPajak.vue?vue&type=template&id=e4167238&scoped=true"
import script from "./FakturPajak.vue?vue&type=script&lang=js"
export * from "./FakturPajak.vue?vue&type=script&lang=js"
import style0 from "./FakturPajak.vue?vue&type=style&index=0&id=e4167238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4167238",
  null
  
)

export default component.exports